<template>
    <modal name="store-update-modal" class="store-update-modal"
           :width="'400px'"
           :height="'auto'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
      <div class="pa15">
        <div class="store_modal_title">상품 상세</div>
        <div class="store-content pt15 pl30 pr30 pb15">
            <div class="c_table_wrap">
                <table class="StoreDetail_table">
                    <colgroup>
                        <col width="270px;">
                        <col width="180px;">
                        <col width="auto;">
                    </colgroup>
                    <tr>
                        <td rowspan="5" class="write_content_td"  @click="openProductPopup()">
                            <img :src="storeData.goodsImgS" class="img-content">
                        </td>
                        <td class="c_t_title">교환처</td>
                        <td colspan="2" class="write_content_td">
                            <div class="write_content_div">
                            {{ storeData.brandName }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">상품권명</td>
                        <td colspan="2" class="write_content_td">
                            <div class="write_content_div">
                                <el-input 
                                v-model="productInput" 
                                placeholder="상품 명을 입력해주세요.">
                            </el-input>
                            <div class="input_error mt10" v-if="validation.hasError('productInput')">{{ validation.firstError('productInput') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">상품 가격</td>
                        <td colspan="2" class="write_content_td">
                            <div class="write_content_div">
                                <el-input 
                                    v-model="priceInput" 
                                    placeholder="상품 가격을 입력해주세요." 
                                    @blur="handlePriceInput(priceInput)">
                                </el-input>
                                <div class="input_error mt10" v-if="validation.hasError('priceInput')">{{ validation.firstError('priceInput') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">노출여부</td>
                        <td colspan="2" class="write_content_td">
                            <div class="write_content_div cell text-center">
                                <el-radio-group class="radioBox" v-model="display">
                                    <el-radio :label="1">노출</el-radio>
                                    <el-radio :label="0">미노출</el-radio>
                                </el-radio-group>
                    
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="c_t_title">노출순서</td>
                        <td colspan="2" class="write_content_td">
                            <div class="write_content_div">
                                <el-input
                                        v-model="seq"
                                        placeholder="노출순서를 입력해주세요."
                                >
                                </el-input>
                                <div class="input_error mt10" v-if="validation.hasError('seq')">{{ validation.firstError('seq') }}</div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="1" class="c_t_title">관리자 비밀번호</td>
                        <td colspan="3" class="write_content_td">
                            <div class="select_wrap">
                                <el-input 
                                    v-model="password" 
                                    type="password" 
                                    maxlength="20" 
                                    placeholder="관리자 비밀번호 입력">
                                </el-input>
                            </div>
                        </td>
                    </tr>
                </table>
                <div class="input_error mt10" v-if="validation.hasError('password')">{{ validation.firstError('password') }}</div>
                <div class="input_error mt10" v-show="errorMsg !== ''">{{ errorMsg }}</div>
            </div>
        </div>
        <div class="btn_wrap text-center mt20">
            <el-button type="save" @click="save">저장</el-button>
            <el-button type="danger" @click="productDelete()">삭제</el-button>
            <el-button type="cancel" @click="close()">닫기</el-button>
          </div>
      </div>
    </modal>
  </template>
  
  <script>

  import util from "@/mixins/util";
  import EventBus from "@/utils/event-bus";
  import alertMixins from "@/mixins/alertMixins";
  import storeValidator from "@/mixins/validators/storeValidator";
  
  export default {
    name: "StoreUpdateModal",
    mixins: [alertMixins, storeValidator],
    components: {},
    inject: ['changeLoading'],
    props: {
    },
    data() {
      return {
        storeData: {},
        index: '',
        errorMsg:'',
      }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
      handlerBeforeOpen(event) {
        if (util.isEmpty(event.params)) {
            event.stop();
        } else {
            this.index = '';
            this.storeData = '';
            this.priceInput = '';
            this.productInput = '';
            this.display = '';
            if ((event.params.hasOwnProperty('data')) && event.params.hasOwnProperty('index') ){
                this.index =   event.params.index;
                this.storeData = event.params.data; 
                this.priceInput = event.params.data.gi_point; 
                this.productInput = event.params.data.gi_name; 
                this.display = event.params.data.gi_display;
                this.seq = event.params.data.gi_seq;
            }
        }
        EventBus.$on("productListSelectAfter",this.productListSelectAfter);
      },
      handlerOpened() {
      },
      handlerBeforeClose() {
        this.password = '';
        this.validation.reset();
        EventBus.$off("productListSelectAfter");
      },
      close(){
        this.$modal.hide('store-update-modal');
      },
      save(){
        this.changeLoading(true);
        this.$validate(['productInput','priceInput', 'display', 'password', 'seq']).then((success) => {
            if (!success) {
                this.changeLoading(false);
                return;
            } 
            return this.updateStoreDatail();
        })
      },
      updateStoreDatail() {
        this.errorMsg = ''
        let params = {
            gi_idx: this.index,
            g_idx: this.storeData.g_idx,
            gi_point: this.priceInput,
            gi_name: this.productInput,
            gi_display: this.display,
            mb_password: this.password,
            gi_seq: this.seq
            }
       
        try {
            this.$api.$store.updateStore(params).then(res => res.Data.Result).then(res => {
                if(res.Info.type === 1) {
                    this.changeLoading(false);
                    this.afterFunc();
                } else if(res.Info.type == -666) {
                    this.changeLoading(false);
                    this.errorMsg = '관리자 비밀번호가 일치하지 않습니다.';
                    this.saveFail();
                } else if(res.Info.type == -112 ) {
                    this.changeLoading(false);
                    this.errorMsg = '판매 종료된 상품입니다.';
                    this.saveFail();
                }
                else if(res.Info.type == -102 ) {
                    this.changeLoading(false);
                    this.errorMsg = '상품이 존재하지 않습니다.';
                    this.saveFail();
                }else {
                    this.saveFail();
                }
            })
        } catch (e) {
            this.changeLoading(false)
            console.log(e);
        }
      },
      afterFunc(){
        this.createAlert({
          content: '수정되었습니다.',
          hide: () => {
            EventBus.$emit('getList');
            this.$modal.hide('store-update-modal');
          }
        })
      },
      saveFail() {
        this.changeLoading(false);
        this.errorAlert('저장에 실패하였습니다.');
      },
      handlePriceInput(priceInput) {
        var pattern = /[^(0-9)]/gi;
        if(pattern.test(priceInput)) {
            this.priceInput = priceInput.replace(pattern, '');
        }
        if(this.priceInput != '') {
            this.priceInput = Number(this.priceInput);
            this.priceInput = Math.round(this.priceInput / 10) * 10;
        }
      },
      returnCommaNPrice(price){
        if (util.isEmpty(price) || isNaN(price)) {
            return 0
        }
        let makePrice = Math.floor(price);
        if (!util.isEmpty(makePrice)) {
            return util.Number.numFormat(makePrice);
        } else {
            return 0;
        }
      },
      productDelete(){
        this.createConfirm({
            content: '해당 상품을 삭제하시겠습니까?',
            confirm: () => {
                this.changeLoading(true);
                this.$validate(['password']).then((success) => {
                    if (!success) {
                        this.changeLoading(false);
                        return;
                    } 
                    return this.deleteFunc();
                })
            }
        })   
      },
      deleteFunc(){
        let params = {
            gi_idx: this.index,
            mb_password: this.password,
        }
       
        try {
            this.$api.$store.deleteStore(params).then(res => res.Data.Result).then(res => {
                if(res.Info.type === 1) {
                    this.changeLoading(false);
                    this.afterDeleteFunc();
                } else if(res.Info.type == -666) {
                    this.changeLoading(false);
                    this.errorMsg = '관리자 비밀번호가 일치하지 않습니다.';
                    this.deleteFail();
                }else {
                    this.deleteFail();
                }
            })
        } catch (e) {
            this.changeLoading(false)
            console.log(e);
        }
      },
      deleteFail() {
        this.changeLoading(false);
        this.errorAlert('삭제에 실패하였습니다.');
      },
      afterDeleteFunc(){
        this.createAlert({
          content: '삭제되었습니다.',
          hide: () => {
            EventBus.$emit('getList');
            this.$modal.hide('store-update-modal');
          }
        })
      },
      openProductPopup(){   
        this.$modal.show('product-list-modal');
      },
      productListSelectAfter(data){
        this.storeData = data;
        this.productInput = data.goodsName
      }
    },
    watch: {
        password(newValue) {
            this.errorMsg = '';
        },
    },
  }
  </script>
  
  <style scoped>
  
  </style>
  